import { kebabCase } from 'lodash';

export const attrSelector = selector => `[data-${kebabCase(selector)}]`;
